import { combineReducers } from "@reduxjs/toolkit";
import assetsReducer from "./assetsSlice";
import attributeGroupsReducer from "./attributeGroupsSlice";

export default combineReducers({
  assets: assetsReducer,
  attributeGroups: attributeGroupsReducer,
});
